module.exports = __webpack_public_path__ + "static/RC-f7a48e572ed51d0d7f42b0ae92ed00ed.jpg";